var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"card-modal__sidebar"},[_c('div',{staticClass:"card-modal__sidebar-wrapper"},[_c('CardModalSidebarLinks'),_c('CardModalSidebarActions',{attrs:{"card":_vm.card}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }